import axios from 'axios'
import { Message, Spin } from 'view-design'
import Cookies from 'js-cookie'
// import config from '@/config'
import { TOKEN_KEY, setToken } from '@/libs/util'
import router from '@/router'

axios.defaults.baseURL = process.env.VUE_APP_API_HOST

axios.interceptors.request.use(
  function (config) {
    if (Cookies.get(TOKEN_KEY)) {
      config.headers.Authorization = Cookies.get(TOKEN_KEY)
      config.headers.ChainStoreId = localStorage.getItem('SHOPID')
    }
    if (config.base) {
      switch (config.base) {
        case 'CONFIG': config.baseURL = process.env.VUE_APP_CONFIG_API_HOST; break
      }
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response) {
      if (/^401$/.test(error.response.status)) {
        Message.error(error.response.data.message)
        setToken('')
        router.replace('/login')
      } else if (/^4.*/.test(error.response.status)) {
        Spin.hide()
        Message.error(error.response.data.message)
      } else {
        Message.error(error.response.data.message)
      }
    }
    return Promise.reject(error.response)
  }
)
